import React from 'react'
import { Link } from 'react-router-dom'

export const Footer = () => {
  return (
    <div className='w-full py-3'>
      <p className='font-dashboard text-white/40 text-xs text-center'>
        COPYRIGHT © {new Date().getFullYear()}{' '}
        <Link to='/' className='text-yellow-500'>
          Gcbuying
        </Link>
        , All rights Reserved
      </p>
    </div>
  )
}
